var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandomProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.47 515.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: #6196ad;\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: #fff;\r\n            }\r\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fichier 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 515.47,
    height: 515.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.67,139.74a86.12,86.12,0,1,1,86.11,86.19A86.23,86.23,0,0,1,171.67,139.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.57,374.14c-33.48,45.51-77.7,74-133.36,84.07-11.62,2.1-23.53,2.6-32.74,3.57-74.56-2.43-131.8-32.14-173.53-91a8.93,8.93,0,0,1-1.12-5.59c1.19-11.93,7-21.7,15-30.23,11.15-11.79,24.77-20,39.28-26.92,26.71-12.67,54.92-20.31,84.07-24.75,16.61-2.53,33.28-3.62,50-2.07a314.26,314.26,0,0,1,81.91,18.62c18.8,7.05,36.75,15.71,52.1,28.94,10,8.66,17.91,18.78,20.92,32.1C430.28,365.77,429.75,369.8,426.57,374.14Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomProfile);
export default __webpack_public_path__ + "static/media/random_profile.638d2918ba1c41e61349e9a90a3b43f1.svg";
export { ForwardRef as ReactComponent };